//ar Event = require("cocos/framework/components/event");

GameSpeedManager = xClass('GameSpeedManager');
require("clover/data/Persistence")

var GameGuideEvents = table(
    [1, "StartGuide", "GAMEGUIDEEVENTS.STARTGUIDE"],
    [1, "EndGuide", "GAMEGUIDEEVENTS.ENDGUIDE"],
    [1, "StartAction", "GAMEGUIDEEVENTS.STARTACTION"],
    [1, "EndAction", "GAMEGUIDEEVENTS.ENDACTION"]
);
/**
 * 管理器实例
 */
var instance = null;

/**
 * 构造函数
 */
GameSpeedManager.prototype.ctor = function () {
    var self = this;

    self.levelType = null;                                      //  当前游戏模式
    self.isReplayPanel = false;                                 //  当前是否处于游戏重开面板
    self.inGameBoard = false;                                   //  当前是否处于关卡场景
    self.homeSceneIndex = -1;                                   //  主场景Level编号
    self.levelTypeEffect = table(                               //  各游戏模式对应的影响系数
        [1, self.homeSceneIndex, true],                         //  homeScene设置，用于影响全局
        // [1, GameLevelType["kQixi"], false],                     //  七夕活动
        [1, GameLevelType["kMainLevel"], true],                 //  主线关卡
        // [1, GameLevelType["kHiddenLevel"], false],
        // [1, GameLevelType["kWeekly"], false],                   //  周赛
        // [1, GameLevelType["kMayDay"], false],
        // [1, GameLevelType["kTaskForRecall"], false],
        // [1, GameLevelType["kTaskForUnlockArea"], false],
        // [1, GameLevelType["kSummerWeekly"], false],
        // [1, GameLevelType["kEditor"], false],
        // [1, GameLevelType["kABTest"], false],
        // [1, GameLevelType["kActivityMissionLevel"], false],
        // [1, GameLevelType["kNewYear2018"], false],
        [1, GameLevelType["kMagic"], false],
        // [1, GameLevelType["kSpring2018"], false],
        // [1, GameLevelType["kStoryActivity"], false],
        // [1, GameLevelType["kLabor"], false],
        [1, GameLevelType["kGold"], false],
        // [1, GameLevelType["kJulyAc"], false],
        // [1, GameLevelType["kAugustRetain"], false],
        // [1, GameLevelType["kNationDay2018"], false],
        // [1, GameLevelType["kMakeTea"], false],
        // [1, GameLevelType["kUnionWar"], false]
        [1, GameLevelType["kPvp"], false], 
        [1, GameLevelType["kOneStep"], false],
        [1, GameLevelType["kTimeBlockCollection"], false],
        [1, GameLevelType["kCoinMatch"], false],
        [1, GameLevelType["kMysteryIsland"], true],
        [1, GameLevelType["kBuildShip"], true],
        // [1, GameLevelType["kBaiduXiaoshu"], false]
    );         
    self.levelTypeSpeed_Default = table(            //  各游戏模式默认速度
        // [1, GameLevelType["kQixi"], GamePlayConfig_GameBoard_Speed_Select_Default],
        [1, GameLevelType["kMainLevel"], GamePlayConfig_GameBoard_Speed_Select_Default],
        // [1, GameLevelType["kHiddenLevel"], GamePlayConfig_GameBoard_Speed_Select_Default],
        // [1, GameLevelType["kWeekly"], GamePlayConfig_GameBoard_Speed_Select_Default],
        // [1, GameLevelType["kMayDay"], GamePlayConfig_GameBoard_Speed_Select_Default],
        // [1, GameLevelType["kTaskForRecall"], GamePlayConfig_GameBoard_Speed_Select_Default],
        // [1, GameLevelType["kTaskForUnlockArea"], GamePlayConfig_GameBoard_Speed_Select_Default],
        // [1, GameLevelType["kSummerWeekly"], GamePlayConfig_GameBoard_Speed_Select_Default],
        // [1, GameLevelType["kEditor"], GamePlayConfig_GameBoard_Speed_Select_Default],
        // [1, GameLevelType["kABTest"], GamePlayConfig_GameBoard_Speed_Select_Default],
        // [1, GameLevelType["kActivityMissionLevel"], GamePlayConfig_GameBoard_Speed_Select_Default],
        // [1, GameLevelType["kNewYear2018"], GamePlayConfig_GameBoard_Speed_Select_Default],
        [1, GameLevelType["kMagic"], GamePlayConfig_GameBoard_Speed_Select_Default],
        // [1, GameLevelType["kSpring2018"], GamePlayConfig_GameBoard_Speed_Select_Default],
        // [1, GameLevelType["kStoryActivity"], GamePlayConfig_GameBoard_Speed_Select_Default],
        // [1, GameLevelType["kLabor"], GamePlayConfig_GameBoard_Speed_Select_Default],
        [1, GameLevelType["kGold"], GamePlayConfig_GameBoard_Speed_Select_Default],
        // [1, GameLevelType["kJulyAc"], GamePlayConfig_GameBoard_Speed_Select_Default],
        // [1, GameLevelType["kAugustRetain"], GamePlayConfig_GameBoard_Speed_Select_Default],
        // [1, GameLevelType["kNationDay2018"], GamePlayConfig_GameBoard_Speed_Select_Default],
        // [1, GameLevelType["kMakeTea"], GamePlayConfig_GameBoard_Speed_Select_Default],
        // [1, GameLevelType["kUnionWar"], GamePlayConfig_GameBoard_Speed_Select_Default]
        [1, GameLevelType["kPvp"], GamePlayConfig_GameBoard_Speed_Select_Default], 
        [1, GameLevelType["kOneStep"], GamePlayConfig_GameBoard_Speed_Select_Default],
        [1, GameLevelType["kTimeBlockCollection"], GamePlayConfig_GameBoard_Speed_Select_TimeBlockCollectionMode],
        [1, GameLevelType["kCoinMatch"], GamePlayConfig_GameBoard_Speed_Select_Default],
        // [1, GameLevelType["kBaiduXiaoshu"], GamePlayConfig_GameBoard_Speed_Select_Default]
        [1, GameLevelType["kMysteryIsland"], GamePlayConfig_GameBoard_Speed_Select_Default],
        [1, GameLevelType["kBuildShip"], GamePlayConfig_GameBoard_Speed_Select_BuildShip],
    );
    self.levelTypeSpeed = table(            //  各游戏模式对应的速度
        // [1, GameLevelType["kQixi"], self.levelTypeSpeed_Default[GameLevelType["kQixi"]]],
        [1, GameLevelType["kMainLevel"], self.levelTypeSpeed_Default[GameLevelType["kMainLevel"]]],
        // [1, GameLevelType["kHiddenLevel"], self.levelTypeSpeed_Default[GameLevelType["kHiddenLevel"]]],
        // [1, GameLevelType["kWeekly"], self.levelTypeSpeed_Default[GameLevelType["kWeekly"]]],
        // [1, GameLevelType["kMayDay"], self.levelTypeSpeed_Default[GameLevelType["kMayDay"]]],
        // [1, GameLevelType["kTaskForRecall"], self.levelTypeSpeed_Default[GameLevelType["kTaskForRecall"]]],
        // [1, GameLevelType["kTaskForUnlockArea"], self.levelTypeSpeed_Default[GameLevelType["kTaskForUnlockArea"]]],
        // [1, GameLevelType["kSummerWeekly"], self.levelTypeSpeed_Default[GameLevelType["kSummerWeekly"]]],
        // [1, GameLevelType["kEditor"], self.levelTypeSpeed_Default[GameLevelType["kEditor"]]],
        // [1, GameLevelType["kABTest"], self.levelTypeSpeed_Default[GameLevelType["kABTest"]]],
        //[1, GameLevelType["kActivityMissionLevel"], self.levelTypeSpeed_Default[GameLevelType["kActivityMissionLevel"]]],
        // [1, GameLevelType["kNewYear2018"], self.levelTypeSpeed_Default[GameLevelType["kNewYear2018"]]],
        [1, GameLevelType["kMagic"], self.levelTypeSpeed_Default[GameLevelType["kMagic"]]],
        // [1, GameLevelType["kSpring2018"], self.levelTypeSpeed_Default[GameLevelType["kSpring2018"]]],
        // [1, GameLevelType["kStoryActivity"], self.levelTypeSpeed_Default[GameLevelType["kStoryActivity"]]],
        // [1, GameLevelType["kLabor"], self.levelTypeSpeed_Default[GameLevelType["kLabor"]]],
        [1, GameLevelType["kGold"], self.levelTypeSpeed_Default[GameLevelType["kGold"]]],
        // [1, GameLevelType["kJulyAc"], self.levelTypeSpeed_Default[GameLevelType["kJulyAc"]]],
        // [1, GameLevelType["kAugustRetain"], self.levelTypeSpeed_Default[GameLevelType["kAugustRetain"]]],
        // [1, GameLevelType["kNationDay2018"], self.levelTypeSpeed_Default[GameLevelType["kNationDay2018"]]],
        // [1, GameLevelType["kMakeTea"], self.levelTypeSpeed_Default[GameLevelType["kMakeTea"]]],
        // [1, GameLevelType["kUnionWar"], self.levelTypeSpeed_Default[GameLevelType["kUnionWar"]]],
        [1, GameLevelType["kPvp"], self.levelTypeSpeed_Default[GameLevelType["kPvp"]]],
        [1, GameLevelType["kOneStep"], self.levelTypeSpeed_Default[GameLevelType["kOneStep"]]],
        [1, GameLevelType["kTimeBlockCollection"], self.levelTypeSpeed_Default[GameLevelType["kTimeBlockCollection"]]],
        [1, GameLevelType["kCoinMatch"], self.levelTypeSpeed_Default[GameLevelType["kCoinMatch"]]],
        //[1, GameLevelType["kBaiduXiaoshu"], self.levelTypeSpeed_Default[GameLevelType["kBaiduXiaoshu"]]]
        [1, GameLevelType["kMysteryIsland"], self.levelTypeSpeed_Default[GameLevelType["kMysteryIsland"]]],
        [1, GameLevelType["kBuildShip"], self.levelTypeSpeed_Default[GameLevelType["kBuildShip"]]],

    );     
    //  读取配置文件
    CfgManager.load("game").then((dataMap)=>{
        let config = CfgManager.get("game");
        let effect = config["game_speed_effect"];
        if (effect == undefined){
            cc.log("game config error!");
        } else {
            for (let i in effect) {
                if (i === "homeScene") {
                    self.levelTypeEffect[self.homeSceneIndex] = effect[i] === 0 ? false : true;
                } else {
                    self.levelTypeEffect[GameLevelType[i]] = effect[i] === 0 ? false : true;
                }
            }
        }
        CfgManager.release("game");
    }).catch((err) => {
        console.error("load game config failed!", err);
    });         
    // 本地是否有老的速度信息
    var oldSpeedData = cc.UserDefault.getInstance().getStringForKey(LOCAL_GAMEBOARD_SPEED_SELECT, "");
    if (oldSpeedData != ""){
        Persistence.writeFileData(oldSpeedData, LocalDataFiles.kGameboardSpeedSelect);
        cc.UserDefault.getInstance().removeKey(LOCAL_GAMEBOARD_SPEED_SELECT);
    }
    //  获取用户本地保存的速度信息，存在则覆盖配置信息
    if (self.haveLocalConfig()) {
        let local_speed = Persistence.readFileData(LocalDataFiles.kGameboardSpeedSelect);
        for (let i in local_speed) {
            self.levelTypeSpeed[i] = parseFloat(local_speed[i]);
        }
    }
    //  添加监听
    GameGuide.getInstance().on(GameGuideEvents.StartGuide, onStartGuide, false);
    GameGuide.getInstance().on(GameGuideEvents.EndGuide, onEndGuide, false);
}
/**
 * 获取单例实例
 */
GameSpeedManager.getInstance = function () {
    if (!instance) {
        instance = GameSpeedManager.new();
    }
    return instance;
}
/**
 * 获取指定模式的当前速度
 * @param levelType 待获取的模式
 */
GameSpeedManager.prototype.getSpeed = function(levelType) {
    var self = this;
    return self.levelTypeSpeed[levelType];
}
/**
 * 获取玩家当前速度配置
 */
GameSpeedManager.prototype.getSpeedConfig = function() {
    var self = this;
    let data = {};
    for (let i in self.levelTypeSpeed) {
        if (i) {
            let index = "speed_" + i;
            data[index] = {
                value: parseFloat(self.levelTypeSpeed[i]),
                dc: self.levelTypeEffect[i]? true: false
            };
        }
    }
    return data;
}
/**
 * 判断本地是否保存游戏速度配置信息
 */
GameSpeedManager.prototype.haveLocalConfig = function () {
    let select = Persistence.readFileData(LocalDataFiles.kGameboardSpeedSelect);
    if (select){
        return true; 
    }else{
        return false;
    }
}
/**
 * 当前游戏类型是否为受游戏速度设置影响的类型
 * @param isHomeScene 当前在检查主界面设置面板
 */
GameSpeedManager.prototype.isEffectLevel = function(isHomeScene = false) {
    var self = this;

    if (isHomeScene) {
        return self.levelTypeEffect[-1];
    } else if (self.levelType !== null) {
        return self.levelTypeEffect[self.levelType];
    } else {
        return false;
    }
}
/**
 * 游戏引导结束回调
 */
onEndGuide = function () {
    //  恢复游戏速度
    let instance = GameSpeedManager.getInstance()
    if (instance.inGameBoard) {
        if (instance.isEffectLevel()) {
            instance.updateGameSpeed();
        } else {
            instance.updateGameSpeed2Default();
        }
    }
}
/**
 * 游戏引导启动回调
 */
onStartGuide = function () {
    let instance = GameSpeedManager.getInstance()
    if (instance.inGameBoard) {
        //  正常速播放引导
        if (instance.isEffectLevel()) {
            instance.updateGameSpeed2Normal();
        }
    }
}
/**
 * 保存玩家设定的速度信息
 */
GameSpeedManager.prototype.saveSpeed = function() {
    var self = this;
    let data = {};
    for (let i in self.levelTypeSpeed) {
        data[i] = self.levelTypeSpeed[i];
    }
    //  保存至本地
    Persistence.writeFileData(JSON.stringify(data), LocalDataFiles.kGameboardSpeedSelect);
    //  上传至服务端
    let http = ClientConfigHttp.new(true)
    function onSuccess() {
        cc.log("Update success");
    }
    function onFail() {
        cc.log("Update Faile");
    }
    function onCancel() {
        cc.log("Update cancel");
    }
    http.addEventListener(Events.kComplete, onSuccess)
    http.addEventListener(Events.kError, onFail)
    http.addEventListener(Events.kCancel, onCancel)
    http.load()
    //  打点，目前只针对主线速度
    if (self.levelType === GameLevelType.kMainLevel) {
        DCAssist.dc4UserGameSpeed()
    }
}
/**
 * 保存从服务端加载的速度
 * @param data
 */
GameSpeedManager.prototype.saveSpeedFromServer = function(data) {
    var self = this;
    for (var i in data) {
        try {
            if (i.substring(0, "speed_".length) === "speed_" && (data[i].value || data[i].value === 0)) {
                let speed = parseInt(i.substring("speed_".length))
                if (typeof speed === 'number' && !isNaN(speed)) {
                    self.levelTypeSpeed[speed] = data[i].value;
                    cc.log(speed + " " + GamePlayConfig_GameBoard_Speed[self.levelTypeSpeed[speed]]);
                }
            }
        } catch (error) {
            //  非速度类型
        }
    }
    //  获取完毕，刷新本地配置
    self.saveSpeed()
}
/**
 * 通过abtest设置默认速度
 * @param abtest 
 */
 GameSpeedManager.prototype.setAllDefaultSpeed = function(abtest) {
    var self = this;
    // GamePlayConfig_GameBoard_Speed_Select_Default

    CfgManager.load("orthogonal_group").then(() => {
        // print("champion_config resolve", CfgManager.get("champion_config"))
        // TimeLimitGiftConfig.init(config);
        let  ortho = CfgManager.get("orthogonal_group").Doublespeed.testInfo.split(";")
        
        CfgManager.release("orthogonal_group");

        for (item of ortho){
            let key = item.split(":")[0]
            let value = tonumber( item.split(":")[1].replace("{","").replace("}",""))
            if (abtest == key){
                for (let i = 0; i < GamePlayConfig_GameBoard_Speed.length; i++){
                    if (value == GamePlayConfig_GameBoard_Speed[i]){
                        // GamePlayConfig_GameBoard_Speed_Select_Default = i
                        // self.setSpeed(GameLevelType["kMainLevel"], i)
                        self.setAllSpeed(i)
                        cc.log("speed setAllDefaultSpeed i", i, value)
                        return
                    }

                }

            }
        }

    })
    // //  获取完毕，刷新本地配置
    // self.saveSpeed()
}
/**
 * 设定全部游戏模式的速度（只设定可以被设定的模式）
 * @param speed     目标速度
 */
GameSpeedManager.prototype.setAllSpeed = function(speed) {
    var self = this;
    for (let i in GameLevelType) {
        if (self.levelTypeEffect[GameLevelType[i]] === true) {
            self.setSpeed(GameLevelType[i], speed, true);
        }
    }
    self.saveSpeed()
}
/**
 * 设定指定游戏模式的速度
 * @param levelType 游戏模式
 * @param speed     目标速度索引
 * @param isAll     是否为全部设定模式（主要减少IO开销）
 */
GameSpeedManager.prototype.setSpeed = function(levelType, speed, isAll = false) {
    var self = this;
    
    try {
        if (self.isEffectLevel(levelType) && typeof(speed) === "number" && !isNaN(speed)) {
            self.levelTypeSpeed[levelType] = speed;
            if (!isAll) {
                self.saveSpeed()
            }
        }
    } catch (err) {
        cc.log(err);
    }
}
/**
 * 更新游戏速度为当前模式的设定值，若当前模式允许用户设定速度，则设定为用户设定的速度
 */
GameSpeedManager.prototype.updateGameSpeed = function() {
    var self = this;
    //  调速至保存值
    self.updateGameSpeedValue(GamePlayConfig_GameBoard_Speed[self.levelTypeSpeed[self.levelType]]);
}
/**
 * 更新游戏速度至默认值
 */
GameSpeedManager.prototype.updateGameSpeed2Default = function() {
    var self = this;

    if (self.levelType) {
        self.updateGameSpeedValue(GamePlayConfig_GameBoard_Speed[self.levelTypeSpeed_Default[self.levelType]]);
    } else {
        self.updateGameSpeed2Normal();
    }
}
/**
 * 恢复游戏速度到正常值
 */
GameSpeedManager.prototype.updateGameSpeed2Normal = function() {
    var self = this;
    self.updateGameSpeedValue(1);
    self._isFishMoveSpeedingUp = false
}
/**
 * 设定游戏速度至重播状态
 */
GameSpeedManager.prototype.updateGameSpeed2Replay = function(replayingStrategy) {
    var self = this;
    if (replayingStrategy == true){
        return;
    }
    self.updateGameSpeedValue(GamePlayConfig_GameBoard_Speed_Replay);
}
/**
 * 更新游戏速度值
 * @param value 速度值
 */
GameSpeedManager.prototype.updateGameSpeedValue = function(value, manual) {
    if (__DEBUG) {
        if (!manual) {
            cc.director._scheduler.setTimeScale(value);
            cc.log("TimeScale change to " + cc.director._scheduler.getTimeScale());
        }
        return;
    }
    cc.director._scheduler.setTimeScale(value);
    cc.log("TimeScale change to " + cc.director._scheduler.getTimeScale());
}

/**
 * 获取游戏当前速度
 */
GameSpeedManager.prototype.getGameSpeedValue = function () {
    var self = this

    return cc.director._scheduler.getTimeScale();
}


/**
 * 获取游戏当前速度index(1,2,3,4)
 */
GameSpeedManager.prototype.getSpeedUpShift = function () {
    var self = this

    return self.getSpeed(self.levelType) + 1;
}

// 小鱼出场动画加速
GameSpeedManager.prototype.speedFishMoveUp = function () {
    let self = this
    // if (!self.isEnableBase()) {
    //     return 
    // }
    // if (self._isSpeedLocked) {
    //     cc.log("锁定变速！")
    //     return 
    // }
    if (self._isFishMoveSpeedingUp) {
        return 
    }
    let speed = 5
    self._isFishMoveSpeedingUp = true
    // let $var63 = $len(self._allSpeedTimelines)
    // for (let i = $var63; i >= 1; i += -1) {
    //     let timeline = self._allSpeedTimelines[i]
    //     if (timeline && !tolua.isnull(timeline)) {
    //         if (timeline.orgTimeSpeed) {
    //             timeline.setTimeSpeed(timeline.orgTimeSpeed * self._normalSpeed / speed)
    //         }
    //     } else {
    //         table.remove(self._allSpeedTimelines, i)
    //     }
    // }
    self.updateGameSpeedValue(speed)
    return true
}
// 小鱼出场动画还原
GameSpeedManager.prototype.speedFishMoveNormal = function () {
    let self = this
    // if (!self.isEnableBase()) {
    //     return 
    // }
    // if (self._isSpeedLocked) {
    //     cc.log("锁定变速！")
    //     return 
    // }
    if (!self._isFishMoveSpeedingUp) {
        return 
    }
    self._isFishMoveSpeedingUp = false
    // cc.Director.getInstance().getScheduler().setTimeScale(self._speedConfig)
    self.updateGameSpeed()
    // for (let i = 1, timeline = self._cacheWaitingSpeedUpTimelines[1]; timeline; i++, timeline = self._cacheWaitingSpeedUpTimelines[i]) {
    //     if (timeline && !tolua.isnull(timeline)) {
    //         timeline.setTimeSpeed(timeline.orgTimeSpeed * self._reverseSpeedUp)
    //     }
    // }
}